import React from "react";
import { observer } from "mobx-react";
import { ValidatedValue } from "../../../helpers/validator";
import TextInput from "../textInput/textInput";

interface FirstNameProps {
  firstName: ValidatedValue<string>;
  disabled?: boolean;
}

export function FirstName(props: FirstNameProps) {

  return (
    <div className="first-name">
      <div className="question-answer-container">
        <div className="question">Imię</div>
        <TextInput
          validatedValue={props.firstName}
          topLabel="Imię"
          disabled={props.disabled}
        />
      </div>
    </div>
  );
}

export default (observer(FirstName));
